import { render, staticRenderFns } from "./PaymentAlipay.vue?vue&type=template&id=36af2ec5&scoped=true"
import script from "./PaymentAlipay.vue?vue&type=script&lang=js"
export * from "./PaymentAlipay.vue?vue&type=script&lang=js"
import style0 from "./PaymentAlipay.vue?vue&type=style&index=0&id=36af2ec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af2ec5",
  null
  
)

export default component.exports